import { Flex, Link, Text } from '@chakra-ui/react';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { CompassIcon } from '../iconComponents/CompassIcon';
import { FavoritesIcon } from '../iconComponents/FavoritesIcon';
import { SixesIcon } from '../iconComponents/SixesIcon';
import { StoreIcon } from '../iconComponents/StoreIcon';
import { handleMenuOpacity } from './MobileFooter';

export const BrowserSidebar = () => {
    const location = useLocation();

    return (
        <Flex className={'browser-sidebar-component'}>
            <Link
                as={ReactRouterLink}
                to="/hosts"
                opacity={handleMenuOpacity(['/hosts'], location.pathname)}
            >
                <CompassIcon />
                <Text>DISCOVER</Text>
            </Link>
            <Link
                as={ReactRouterLink}
                to="/following"
                opacity={handleMenuOpacity(['/following'], location.pathname)}
            >
                <FavoritesIcon />
                <Text>FOLLOWING</Text>
            </Link>
            <Link
                as={ReactRouterLink}
                to="/games"
                opacity={handleMenuOpacity(['/games', '/game/'], location.pathname)}
            >
                <SixesIcon />
                <Text>SIXES</Text>
            </Link>
            <Link
                as={ReactRouterLink}
                to="/store"
                opacity={handleMenuOpacity(['/store'], location.pathname)}
            >
                <StoreIcon />
                <Text>STORE</Text>
            </Link>
        </Flex>
    );
};
